angular.module("EICDataStream3.checkboxList", [])
.directive('eicCheckboxList',
  function() {
    return {      
      scope: {
        items: '=listItems',                   // list of types with selected fields
        selectedValues: '=selectedValues',
        controlName: '@',
        title: '@',
        required: '@',
        forceRow: '@'

      },
      replace: true,

      link: function($scope, iElement, attrs) {
        $scope.minRequired = parseInt(attrs.required) || 0;
        $scope.forceRow = attrs.forceRow?.toLowerCase() === "true" || false;
        
      },



      //template: "<div id='{{controlName}}' style='clear:both;margin-top:10px;margin-bottom:5px;'><table><tr> \
      //             <td style='vertical-align:middle;padding-bottom:8px;'><label>{{title}}</label></td>\
      //             <td style='vertical-align:middle;padding-left:10px'>\
      //              <ul class='list-inline'>\
      //                <li ng-repeat='item in items' style='padding-left:0; margin-right:15px' ng-if='item.visible(item.value)'> \
      //                  <label style='font-weight:normal;margin:0;' class='checkbox' for='{{controlName}}{{item.value}}'>\
      //                    <input type='checkbox' ng-model='item.selected' name='group' id='{{controlName}}{{item.value}}' style='margin-top:2px;' />{{item.text}} \
      //                  </label> \
      //                </li>\
      //              </ul>\
      //             </td>\
      //           </tr></table></div>",


      //ng-style='{''float'': forceRow ? ''left'':''none'' }'

      //ng-style={{(forceRow == `true`) ? mobileStyles : desktopStyles}}
 template: "\
<div id='{{controlName}}' class='form-inline'>\
  <div class='form-group' ng-cloak>\
    <div class='radio'\
         style='margin-right: 10px;'\
         ng-if='item.visible(item.value)'\
         ng-repeat='item in items '\
         ng-style={{forceRowStyles}} >\
      <label for='{{controlName}}{{item.value}}'>\
        <input type='checkbox' name='{{controlName}}_group' id='{{controlName}}{{item.value}}' \
               value='{{item.value}}'\
               ng-model='item.selected'>\
               {{ item.text }}\
      </label>\
    </div>\
    </div>\
  <div  style='clear-both'></div>\
</div>\
    ",


  // <div class="form-inline" style= "margin-top: 5px;" >
  //      <label>Industry Sector:</label> <br />
  //      <div class="form-group" ng-cloak>
  //      <div class="radio"
  //      style="margin-right: 10px;"
  //      ng-if="sector.visible(sector.value)"
  //      ng-repeat="sector in energySectors.listItems ">
  //      <label>
  //      <input type="radio" name="energySectorSelector"
  //      value="{{sector.value}}"
  //      ng-model="energySectors.selected">
  //      {{ energySectors.names[sector.value] }}
  //  </label>
  //</div>
  //</div>

  //</div>
  //<hr style="margin-top: 5px;" />


      controller: ['$scope',
        function($scope) {
          $scope.componentName = "eicCheckboxList";

          $scope.mobileStyles = "{ 'float': 'left', 'margin-top': 0 }"; 
          $scope.desktopStyles = "{}";

          $scope.forceRowStyles = ($scope.forceRow == "true")
            ? "{ 'float': 'left', 'margin-top': 0 }"
            : "{}";
          //$scope.selection = {
          //  ids: {},
          //  objects: []
          //};

          //$scope.selected = false;

          var setInitialSelections = function() {
            // bail out if selectedValues have not been provided
            if(!$scope.selectedValues) return;

            // run through the objects. If the value is in the selected list
            // set its selected property true (false otherwise)
            for (var i = 0; i < $scope.items.length; i++) {
              var o = $scope.items[i];
              o.selected = ($scope.selectedValues.indexOf(o.value) !== -1);
            }
          };


          var syncSelectedItems = function() {
            $scope.selectedValues = [];
            for (var i = 0; i < $scope.items.length; i++) {
              var o = $scope.items[i];
              if (o.selected) {
                $scope.selectedValues.push(o.value);
              }

            }
          };


          $scope.$watch("items", function () {
            if (!$scope.items) return;
            
            var selectedItems =  $scope.items.reduce(function(count, object){
                if(object.selected)  count++;
                return count;
            }, 0);

            if (selectedItems < $scope.minRequired) {
              setInitialSelections();
            }
            else{
              syncSelectedItems();
            }

          }, true);


          //function getItemById (id) {
          //  for (var i = 0; i < $scope.items.length; i++) {
          //    if ($scope.items[i].id == id) {
          //      return $scope.items[i];
          //    }
          //  }
          //};






          setInitialSelections();

        }]
    };
  });


